export default function CTASection() {
  return (
    <section id="contact" className="py-20 bg-gradient-to-br from-blue-900 to-blue-800 relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-96 h-96 bg-teal-400 rounded-full filter blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-orange-400 rounded-full filter blur-3xl"></div>
      </div>
      
      <div className="max-w-4xl mx-auto px-6 text-center relative z-10">
        <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6">
          Ready to Simplify Your <strong>Business Finances</strong>?
        </h2>
        <p className="text-xl text-blue-100 mb-8 leading-relaxed">
          Get started with professional <strong>QuickBooks bookkeeping services in El Paso</strong> today. Schedule your free consultation and discover how we can help your business thrive.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-12">
          <a 
            href="#" 
            onClick={(e) => {
              e.preventDefault();
              window.scrollTo({ top: 0, behavior: 'smooth' });
            }}
            className="bg-teal-500 text-white px-8 py-4 rounded-full text-lg font-medium hover:bg-teal-600 transition-colors shadow-lg whitespace-nowrap cursor-pointer inline-block"
          >
            Get Your Free Consultation
          </a>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mt-16">
          <div className="text-white">
            <div className="w-16 h-16 bg-teal-500 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-phone-line text-2xl"></i>
            </div>
            <h3 className="font-bold text-lg mb-2">Quick Response</h3>
            <p className="text-blue-200 text-sm">We respond to all inquiries within 24 hours</p>
          </div>
          <div className="text-white">
            <div className="w-16 h-16 bg-teal-500 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-shield-check-line text-2xl"></i>
            </div>
            <h3 className="font-bold text-lg mb-2">No Obligation</h3>
            <p className="text-blue-200 text-sm">Free consultation with no commitment required</p>
          </div>
          <div className="text-white">
            <div className="w-16 h-16 bg-teal-500 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-map-pin-2-line text-2xl"></i>
            </div>
            <h3 className="font-bold text-lg mb-2">Local Service</h3>
            <p className="text-blue-200 text-sm">Proudly serving El Paso and West Texas</p>
          </div>
        </div>
      </div>
    </section>
  );
}
